import React, { Fragment } from 'react';
import AbstractComponent from '../../AbstractComponent';

import { getAppUrlImg } from '../../../helper/Url';

import './Preload.css';

class PreloadContent extends AbstractComponent {       
    show() {
        if(!this.props.show)
            return ; 

        return (
            <main>                                                
                <div className="container-fluid">                                                           
                    <div 
                        className="col-md-12 
                                   col-sm-12
                                   col-lg-12
                                   col-xs-12 
                                   text-center
                                   container-center" 
                        style={{height: this.props.height}}                       
                    >
                        <div className="container-center-interno">
                            <img 
                                src={getAppUrlImg() + "preload_botao.gif"} 
                                alt="Loading..." 
                                width='35px' 
                                height='35px'
                                style={{
                                    justifyContent: 'center',
                                    alignItems: 'center'
                                }}

                            /> 
                        </div>
                    </div>                                                        
                </div>
            </main>            
        );
    }

    render() {
        return (
            <Fragment>
                {this.show()}
            </Fragment>
        )
    }
}

PreloadContent.defaultProps = {
    className: '',
    show: false
}

export default PreloadContent;